module.exports = "<div class=\"wrapper wrapper-full-page\">\r\n<router-outlet></router-outlet>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/auth.component.html
// module id = 568
// module chunks = 0